import { render } from "./EditAreaConcentracao.vue?vue&type=template&id=2df995d8"
import script from "./EditAreaConcentracao.vue?vue&type=script&lang=js"
export * from "./EditAreaConcentracao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__